import clsx from 'clsx';
import isFunction from 'lodash/isFunction';
import { Transition } from '@headlessui/react';
import type { MouseEvent } from 'react';

import { PoppyRedCircle } from './shapes/PoppyRedCircle';
import { SunshineYellowCircle } from './shapes/SunshineYellowCircle';
import { PureBlueTriangles } from './shapes/PureBlueTriangles';
import { CloseButton } from 'components/CloseButton';
import { Link } from 'components/Link';
import { AppRoutes } from 'util/urlFactory';

import type { HiringHeroSmallBannerProps } from './HiringHeroSmallBanner.types';

export const HiringHeroSmallBanner = (props: HiringHeroSmallBannerProps) => {
  const { onClick, onClose } = props;

  const isClickable = isFunction(onClick);
  const isClosable = isFunction(onClose);

  return (
    <div
      onClick={onClick}
      className={clsx('bg-primary-pure-blue overflow-hidden  h-[58px]', {
        'cursor-pointer': isClickable,
      })}
    >
      <div className="relative flex items-center justify-center w-full h-full mx-auto max-w-7xl">
        <Transition
          appear
          show
          className="absolute bottom-0 left-0"
          enter="transition-transform duration-1000"
          enterFrom="-translate-x-full translate-y-full"
          enterTo="translate-x-0 translate-y-0"
        >
          <PoppyRedCircle />
        </Transition>
        <Transition
          appear
          show
          className="absolute top-1/2 -translate-y-1/2 left-[10%] max-lg:hidden"
          enter="transition-transform duration-1000"
          enterFrom="-translate-y-[200px]"
        >
          <PureBlueTriangles />
        </Transition>
        <Transition
          appear
          show
          className="absolute top-0 right-0 md:right-[15%]"
          enter="transition-transform duration-1000"
          enterFrom="translate-x-full -translate-y-full"
          enterTo="translate-x-0 translate-y-0"
        >
          <SunshineYellowCircle />
        </Transition>

        {isClickable ? (
          <div className="absolute right-0 flex items-center gap-2 -translate-y-1/2 max-md:text-sm top-1/2">
            <Link
              className="text-sm font-bold underline max-md:hidden underline-offset-2 text-tertiary-blue-200 true-hover:text-white"
              href={AppRoutes.HIRING_HEROS_LANDING_PAGE}
              onClick={(event) => {
                event.stopPropagation();
                onClick();
              }}
            >
              Tell me more!
            </Link>
            {(isClosable || null) && (
              <CloseButton
                className="true-hover:!text-white z-10"
                onClick={(event: MouseEvent<HTMLElement>) => {
                  event.stopPropagation();
                  onClose();
                }}
              >
                Dismiss
              </CloseButton>
            )}
          </div>
        ) : null}

        <h3 className="relative text-sm font-bold select-none max-sm:max-w-xs e max-sm:text-center md:text-base lg:text-lg text-tertiary-blue-200">
          Become a Hiring Hero: Gain visibility, attract applicants, and hire faster!
        </h3>
      </div>
    </div>
  );
};

HiringHeroSmallBanner.displayName = 'HiringHeroSmallBanner';
